<template>
    <div class="library">
        <Header />
        <div class="library-container">
            <h2 class="title">Biblioteca Unimais</h2>
            <p class="subtitle">Pesquise por temas, trechos, palavras-chave, e encontre o seu material.📚</p>
            <Search @filtro-atualizado="atualizarFiltro" />
            <!-- Lista de livros (cards) -->
            <div class="pdf-grid">
                <CardDiscipline v-for="pdf in filteredPdfs" :key="pdf.codigo_disciplina" :discipline="pdf" />
                <div v-if="filteredPdfs.length === 0 && !loading" class="no-results">
                    Nenhum curso encontrado.
                </div>
                <div v-if="loading" class="loading">
                    Carregando cursos...
                    <div v-if="loading" class="spinner"></div>
                </div>  
            </div>

        </div>
    </div>
</template>

<script>
import '../styles/Library.css';
import Header from '../components/Header.vue';
import CardDiscipline from '../components/CardDiscipline.vue';
import request from '../router/request';
import Search from '../components/Search.vue';
import token from '../scripts/token';

export default {
    name: 'LibraryView',
    components: {
        Header,
        CardDiscipline,
        Search,
    },
    data() {
        return {
            search: '',
            filtroArea: '',
            listaArea: [],
            pdfs: [],
            selectedBook: null,
            objetoVisualizar: {},
            viewDoc: '',
            pdfLista: [],
            currentPDF: 0,
            showModal: false,
            loading: false,
        };
    },
    methods: {
        atualizarFiltro(filtro) {
            this.search = filtro.texto; // Atualiza a propriedade search
            this.filtroArea = filtro.area; // Atualiza a nova propriedade filtroArea para a área
        }
    },
    computed: {
        filteredPdfs() {
            if (!Array.isArray(this.pdfs)) return [];
            let filtered = this.pdfs.filter(pdf => {
                const nomeMatch = !this.search || pdf.nome_disciplina.toLowerCase().includes(this.search.toLowerCase());

                // AQUI ESTÁ O AJUSTE CRÍTICO:
                // Compara o codigo_grupo do PDF (que vem do SELECT) com o filtroArea (o codigo_grupo selecionado no dropdown)
                const areaMatch = !this.filtroArea || pdf.codigo_grupo == this.filtroArea;

                return nomeMatch && areaMatch;
            });

            return filtered.sort((a, b) => {
                // Remove espaços e caracteres invisíveis do início, para evitar que quebrem a ordem alfabética
                const nameA = (a.nome_disciplina || '').toString().replace(/^[^a-zA-Z0-9À-ÿ]+/g, '').trim();
                const nameB = (b.nome_disciplina || '').toString().replace(/^[^a-zA-Z0-9À-ÿ]+/g, '').trim();
                
                return nameA.localeCompare(nameB, 'pt-BR', { sensitivity: 'base' });
            });
        }
    },
    mounted() {
        window.scrollTo(0, 0);
        token.validarToken();
        token.startTokenRefreshInterval();

        // Carregar livros
        this.loading = true;
        request.post('ava/listarBiblVirtual')
            .then(response => {
                const resultado = response.data;
                
                if (Array.isArray(resultado)) {
                    this.pdfs = resultado;
                } else if (Array.isArray(resultado.data)) {
                    this.pdfs = resultado.data;
                } else {
                    console.warn('Resposta inesperada para listarBiblVirtual:', resultado);
                    this.pdfs = [];
                }
            })
            .catch(err => {
                console.error('Erro ao carregar livros:', err);
                this.pdfs = [];
            })
            .finally(() => {
                this.loading = false;
            });
    },
    beforeUnmount() {
        token.stopTokenRefreshInterval(); 
    }
};
</script>
